module.exports = __webpack_public_path__ + "img/separatorImg2.c94ff6ad.jpg";